import { Branch } from '../../../dorian-shared/types/branch/Branch';

export interface NodeGetterContext {
  draft: Branch | null;
  branches: Branch[];
}

/**
 * Returns a Branch by its id.
 *
 * Resolution order:
 * 1. Draft: if the in-progress snapshot matches the requested id, return it.
 *    The draft is always fresher than the cache for the node currently being edited.
 * 2. Cache: fall back to the client-side branch cache (state.branch[]).
 * 3. null: node not found in either source.
 */
export type NodeGetter = (branchId: number) => Branch | null;

export function createNodeGetter({ draft, branches }: NodeGetterContext): NodeGetter {
  return (branchId: number): Branch | null => {
    if (draft?.id === branchId) {
      return draft;
    }
    return branches.find((b) => b.id === branchId) ?? null;
  };
}
